<template>
  <div class="user-actions">
    <AppHeader 
      class="app-header--dark"
    />
    <v-container
      grid-list-md
      class="white--text"
    >
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <h1
            class="user-actions__title"
            v-html="formTitle"
          />
          <div class="user-actions__body">
            <slot />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import AppHeader from './AppHeader';
  export default {
    name: 'UserActionsWrap',
    props: ['formTitle'],
    components: {
      AppHeader
    }
  }
</script>

<style scoped>
  .user-actions {
    background-color: #212121;
    min-height: calc(100vh - 100px);
  }

  .user-actions__title {
    position: relative;
    font-weight: bold;
    padding-bottom: 15px;
    margin: 50px;
    font-size: 30px;
    line-height: 35px;
  }

  .user-actions__title::after {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    content: '';
    width: 50px;
    height: 1px;
    background-color: #fff;
  }
  .user-actions__body {
    padding: 0 30px;
  }

  .input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    background-color: transparent;
  }
</style>

